import type {Recommendation} from './Recommendation.js'
import type {RecommendationSource} from './RecommendationSource.js'
import type {ConnectionId} from '../connection/index.js'
import type {RecommendationSourceType} from './RecommendationSourceType.js'

export const mergeRecommendationSources = (
  sourceType: RecommendationSourceType,
  connectionId: ConnectionId,
  recommendations: Recommendation[],
): RecommendationSource => {
  const sources = recommendations
    .map((recommendation) => recommendation.source)
    .filter((source) => source.type === sourceType)
    .filter((source) => source.connectionId === connectionId)

  switch (sourceType) {
    case 'ical': {
      return {
        type: sourceType,
        connectionId,
        events: sources.filter((source) => source.type === 'ical').flatMap((source) => source.events),
      }
    }

    case 'github-commit': {
      return {
        type: sourceType,
        connectionId,
        pushes: sources.filter((source) => source.type === 'github-commit').flatMap((source) => source.pushes),
      }
    }

    case 'jira-issue': {
      return {
        type: sourceType,
        connectionId,
        issues: sources.filter((source) => source.type === 'jira-issue').flatMap((source) => source.issues),
      }
    }

    default:
      throw `Can't merge sources of type ${sourceType}`
  }
}
